//export const BASE_URL = "http://localhost/uniform/backend/api/";
 export const BASE_URL = "https://uniform.vdcapp.in/backend/api/";
//export const BASE_URL1 = "http://localhost/uniform/backend/";
 export const BASE_URL1 = "https://uniform.vdcapp.in/backend/";
